<template>
  <Row class="Splitter">
    <Column class="left" :lg="left">
      <slot name="left" />
    </Column>
    <Column class="right" :lg="right">
      <div class="Splitter-container">
        <div class="Splitter-body">
          <slot name="right" />
        </div>
      </div>
    </Column>
  </Row>
</template>

<script>
export default {
  props: {
    left: { type: Number, default: 6 },
    right: { type: Number, default: 6 },
  },
}
</script>

<style lang="scss">
.Splitter {
  flex-direction: column;
  @include lg {
    flex-direction: row;
  }

  .right,
  .left {
    @include lg {
      width: 100%;
    }
  }

  &-container {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
  }

  &-body {
    max-width: 35rem;
    padding-bottom: 2rem;
    padding-top: 2rem;
    @include lg {
      padding-bottom: 0;
      padding-top: 0;
    }
  }

  &.reverse {
    @include lg {
      flex-direction: row-reverse;
    }
  }
}
</style>
